import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

/**
 * Helligdager fra `company_holidays` som `yyyy-MM-dd`-sett for ett år
 * (VIB-1224). Samme kilde som kapasitetsreduksjonen i faktureringsgrad
 * (VIB-916, `src/lib/billing-query.ts`). Brukes av auto-forslaget for
 * `weekend_holiday_hours` i føringsflatene.
 */
export async function fetchHolidaySet(fromDate: string, toDate: string): Promise<Set<string>> {
  const { data, error } = await supabase
    .from("company_holidays")
    .select("date")
    .gte("date", fromDate)
    .lte("date", toDate);
  if (error) throw error;
  return new Set((data ?? []).map((r: { date: string }) => r.date));
}

export function useCompanyHolidays(year: number) {
  return useQuery({
    queryKey: ["company-holidays", year],
    staleTime: 5 * 60 * 1000,
    queryFn: () => fetchHolidaySet(`${year}-01-01`, `${year}-12-31`),
  });
}
